import useUrlStateNumber from "@/hooks/useUrlStateNumber";
import { usePatchUserSettings, useUserSettings } from "@/hooks/useUserSettings";
import { ReactNode, createContext, useEffect, useState } from "react";

export interface YearContextProps {
  year: number | undefined;
  updateYear: (year: number) => void;
}

export const YearContext = createContext<YearContextProps>({
  year: undefined,
  updateYear: () => {},
});

export default function YearProvider({ children }: { children: ReactNode }) {
  const { data: userSettingsData } = useUserSettings();
  const patchUserSettings = usePatchUserSettings();

  const [urlYear, setUrlYear] = useUrlStateNumber("year", undefined, true);
  const [year, setYear] = useState<number | undefined>(urlYear);

  const updateYear = (newYear: number) => {
    setYear(newYear);
    setUrlYear(newYear);
    patchUserSettings.mutateAsync({ dashboard_year: newYear });
  };

  useEffect(() => {
    if (!year && userSettingsData) {
      setYear(userSettingsData.dashboard_year);
      setUrlYear(userSettingsData.dashboard_year);
    }
  }, [year, userSettingsData]);

  return <YearContext.Provider value={{ year, updateYear }}>{children}</YearContext.Provider>;
}
